import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-total-count-card',
  templateUrl: './total-count-card.component.html',
  styleUrl: './total-count-card.component.css'
})
export class TotalCountCardComponent {
  env = environment;
  @Input() public title: string;
  @Input() public total: number=0;
}
